

const Button = ({children}) => {
    return (
      <button className="btn--2">
          {children}
      </button>
    )
  }
  
  export default Button